import useInbox from "../useInbox"

const useForm11Inbox = ({ tenantId, filters, config ,userBsinessService: BussinessIds}) => {
    
    const {applicationStatus, mobileNumber, applicationNumber, sortBy, sortOrder, locality, uuid, limit, offset } = filters
    const USER_UUID = Digit.UserService.getUser()?.info?.uuid;    
   const _filters = {
        tenantId,
		processSearchCriteria: {
            moduleName: "bpa-services",
			businessService: BussinessIds,
            ...(applicationStatus?.length > 0 ? {status: applicationStatus} : {}),
            ...(uuid && Object.keys(uuid).length > 0 ? {assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : ""} : {}),
        },
		moduleSearchCriteria: {
            ...(mobileNumber ? {mobileNumber}: {}),
            ...(applicationNumber ? {applicationNumber} : {}),
            ...(sortBy ? {sortBy} : {}),
            ...(sortOrder ? {sortOrder} : {}),
            ...(locality?.length > 0 ? {locality: locality.map((item) => item.name.split("_").pop()).join(",")} : {}),
        },
        limit,
        offset
    }

    return useInbox({tenantId, filters: _filters, config:{

        select: (data) =>({
            statuses: data.statusMap,
            table: data?.items.map( application => ({
                applicationId: application.businessObject.applicationNo,
                date: application.businessObject.auditDetails.createdTime,
                businessService: application.businessObject.businessService,
                status: application.businessObject.status,
                owner: application.businessObject?.landInfo?.owners?.[0]?.name,
                applicationType: application?.businessObject?.applicationType,
                userPhoto:application.businessObject?.landInfo?.owners?.[0]?.photo,
                location: application?.businessObject?.location1,
                registrationNo: application?.businessObject?.registrationNo,
                nextAction: application.ProcessInstance?.nextActions?.[0]?.action
            })),
            totalCount: data.totalCount
        }),
        ...config
    }})
}

export default useForm11Inbox